// @ts-strict-ignore
import type { MatrixModel } from 'flow/store/engine/types';
import type { Axis } from '../AxisHeaderDropdown';
import { AXIS_HIGH_UNBOUNDED_NUMBER, AXIS_LOW_UNBOUNDED_NUMBER } from '~/dashboard/views/workflows/service/actions';

export const getValueOrUndefined = (value: string | number) => (value !== null
  ? value : undefined);

export const getDefaultRangeText = (
  axis: Axis, axisOrder: MatrixModel['axis']['x' | 'y']['order'], isLastBucket: boolean,
) => {
  if (isLastBucket) {
    return (
      // for all bounded ranges - regardless of axisOrder,
      // the last bucket is inclusive of the last value (i.e. <= X <= value)
      axisOrder === 'asc'
        ? `<= ${axis} <=` // value <= X <= value
        : `> ${axis} >=` // value > X >= value
    );
  }
  return (
    axisOrder === 'asc'
      ? `<= ${axis} <` // value <= X < value
      : `> ${axis} >=` // value > X >= value
  );
};

export const getUnboundedHighRangeText = (
  axis: Axis, axisOrder: MatrixModel['axis']['x' | 'y']['order'],
) => (
  axisOrder === 'asc'
    ? `=< ${axis}` // "value =< X"
    : `${axis} >` // "X > value"
);

export const getUnboundedLowRangeText = (
  axis: Axis, axisOrder: MatrixModel['axis']['x' | 'y']['order'],
) => (
  axisOrder === 'asc'
    ? `${axis} <` // "X < value"
    : `> ${axis}` // " value > X"
);

export const isValueUnboundedHighRange = value => +value === AXIS_HIGH_UNBOUNDED_NUMBER;
export const isValueUnboundedLowRange = value => +value === AXIS_LOW_UNBOUNDED_NUMBER;

export const addToAxisHeader = ({
  axisHeader, axisHeaderDataType,
}: MatrixModel['axis']['x' | 'y']) => {
  const updatedAxisHeader = [...axisHeader];

  if (axisHeaderDataType === 'number') {
    const lastElement = axisHeader[axisHeader.length - 1];
    if (
      isValueUnboundedHighRange(lastElement)
      || isValueUnboundedLowRange(lastElement)
    ) {
      updatedAxisHeader.splice(axisHeader.length - 1, 0, null);
      return updatedAxisHeader;
    }
  }

  updatedAxisHeader.push(null);
  return updatedAxisHeader;
};

export const deleteLastAxisHeader = ({
  axisHeader, axisHeaderDataType,
}) => {
  const updatedAxisHeader = [...axisHeader];

  if (axisHeaderDataType === 'number') {
    const lastElement = axisHeader[axisHeader.length - 1];
    if (
      isValueUnboundedHighRange(lastElement)
      || isValueUnboundedLowRange(lastElement)
    ) {
      updatedAxisHeader.splice(axisHeader.length - 2, 1);
      return updatedAxisHeader;
    }
  }

  updatedAxisHeader.pop();
  return updatedAxisHeader;
};
